import {ChoiceGroup, DefaultButton, PrimaryButton, SearchBox, SharedColors, Stack} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddTask from "../Panel/Task/AddTask";
import {Outlet, useNavigate, useOutletContext} from "react-router-dom";


function Task() {
    const [user] = useContext(AuthContext);
    const [searchbox, setSearchbox] = useState('')
    const [count, setCount] = useState({'new': 0, 'current': 0, 'closed': 0, 'rejected': 0});
    const [refresh, setRefresh] = useState(0);
    const [filter, setFilter] = useState('open');
    const [userFilter, setUserFilter] = useState(null)
    const actions = useOutletContext();
    const navigate = useNavigate();
    const userFilters = [
        {id: 'me', text: 'Przypisane do mnie'},
        {id: 'unassigned', text: 'Nieprzypisane'}
    ]
    const [addTask, setAddTask] = useState(false)

    const _filterByUser = (item) => {
        return (
            <Stack.Item align={"end"}>
                {userFilter === item.id ? (
                    <PrimaryButton align="end" key={item.id} onClick={() => setUserFilter(null)}>{item.text}</PrimaryButton>
                ) :(
                    <DefaultButton key={item.id} onClick={() => setUserFilter(item.id)}>{item.text}</DefaultButton>
                )}
            </Stack.Item>
        )
    }

    const _choiceWithNumber = (props, render, number) => {
        return (
            <div>
                {render(props)}
                <span style={{position: 'absolute', right: 5, bottom: 5, color: SharedColors.gray10, fontSize: 12}}>{number}</span>
            </div>
        );
    };

    useEffect(() => {
        actions([
            {
                key: 'addTask',
                text: 'Dodaj Zadanie',
                iconProps: {iconName: 'Add'},
                onClick: () => setAddTask(true)
            },
            {
                key: 'urgent',
                text: 'Pilna Decyzja',
                iconProps: {iconName: 'warning'},
                onClick: () => {
                    window.open(`/api/report/close_tasks?auth=${user.token}`, '_blank').focus();
                }
            },
        ]);
        return actions;
    }, []);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/task/count`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setCount(data.count);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [refresh]);

    const options = [
        {key: 'open', text: 'Nowe', iconProps: {iconName: 'ReportWarning'}, onRenderField: (props, render) => _choiceWithNumber(props, render, count.new)},
        {key: 'current', text: 'W trakcie', iconProps: {iconName: 'ProgressRingDots'}, onRenderField: (props, render) =>  _choiceWithNumber(props, render, count.current)},
        {key: 'closed', text: 'Zamknięte', iconProps: {iconName: 'CheckMark'}, onRenderField: (props, render) =>  _choiceWithNumber(props, render, count.closed)},
        {key: 'rejected', styles: {labelWrapper: {maxWidth: 80}}, text: 'Odrzucono', iconProps: {iconName: 'Blocked'}, onRenderField: (props, render) =>  _choiceWithNumber(props, render, count.rejected)},
    ];

    return (
        <AppContent title={'Zadania'}>
            <Stack enableScopedSelectors horizontal tokens={{childrenGap: 'l1'}}>
                <Stack.Item>
                    <ChoiceGroup selectedKey={filter} options={options} onChange={(e, val) => {setFilter(val.key); navigate(val.key)}}/>
                </Stack.Item>
                <Stack horizontal tokens={{childrenGap: 's1'}}>
                    {userFilters.map(_filterByUser)}
                </Stack>
                <Stack.Item align={"end"}>
                    <SearchBox styles={{root: { width: 250 }}} placeholder="Wyszukaj kontrakt lub projekt" value={searchbox} onChange={(e, value) => setSearchbox(value)} />
                </Stack.Item>
            </Stack>

            <Outlet context={{
                userFilter, searchbox, refresh, setRefresh
            }}/>

            <AddTask onSuccess={() => setRefresh(refresh + 1)} add={addTask} dismissPanel={() => setAddTask(false)}/>
        </AppContent>
    );
}

export default Task;